import { SuccessScreen } from '../features/checkout/SuccessScreen'

export function CheckoutSuccessPage() {
  return <SuccessScreen />
}
